import { cloudImg } from '../config/images';

export const beaches = [
  {
    id: "payyambalam",
    title: "PAYYAMBALAM BEACH",
    description: "The crown jewel of Kannur's magnificent coastline, Payyambalam Beach stretches for an impressive 10 kilometers of pristine golden sand. This world-class destination perfectly embodies Kerala's coastal beauty and offers an unforgettable experience for every type of traveler.",
    features: [
      { highlight: "Spectacular Sunsets", details: "Famous throughout Kerala for its breathtaking sunsets that paint the Arabian Sea in brilliant colors of gold, orange, and crimson. The shallow, crystal-clear waters provide safe swimming conditions for families." },
      { highlight: "Adventure & Activities", details: "From peaceful morning jogs along the endless shoreline to thrilling water sports, this beach caters to every adventure level. Experience surfing, kayaking, parasailing, or simply enjoy long romantic walks on the soft sand." },
      { highlight: "Family Paradise", details: "The adjacent Payyambalam Beach Park features beautifully landscaped gardens, children's play areas, and impressive sculptures by renowned local artists." }
    ],
    location: "https://maps.app.goo.gl/wJdY8ZEknx6ye62q9",
    moreInfo: "https://www.keralatourism.org/destination/payyambalam-beach-kannur/82/",
    image: cloudImg('payyamballam.jpg')
  },
  {
    id: "ezhara",
    title: "EZHARA BEACH",
    description: "A beautiful, quiet, and secluded beach that offers the perfect escape from crowded tourist destinations. This hidden gem is fringed with swaying palm trees and features stunning rocky outcrops that create natural pools during low tide.",
    features: [
      { highlight: "Peaceful Atmosphere", details: "Experience true tranquility at this secluded paradise where the sound of gentle waves creates a natural soundtrack for relaxation." },
      { highlight: "Natural Beauty", details: "Towering palm trees provide natural shade while dramatic rocky formations add character to the pristine golden shoreline." }
    ],
    location: "https://maps.app.goo.gl/X9UxjdAqT8hbrnNM9",
    moreInfo: "https://www.keralatourism.org/ebooks/expect-the-unexpected/kizhunna-ezhara-beach/11",
    image: cloudImg('ezhara_beach.jpg')
  },
  {
    id: "muzhappilangad",
    title: "MUZHAPPILANGAD DRIVE-IN BEACH",
    description: "Muzhappilangad Beach offers the perfect blend of adventure and serene coastal beauty. Located 7 km from Thalassery in Kannur, Kerala, this 4-kilometer stretch along the Malabar coast is Asia's longest drive-in beach, where you can drive your car or bike right on the sand with the sea breeze in your hair.",
    features: [
      { highlight: "Unique Drive-In Experience", details: "Asia's longest drive-in beach where you can literally drive your vehicle on the sand - a once-in-a-lifetime experience that combines the thrill of driving with coastal beauty." },
      { highlight: "Safe Swimming & Natural Protection", details: "Natural black rocks protect the beach from strong ocean currents, making it a swimmer's paradise with calm, safe waters for families." }
    ],
    location: "https://maps.app.goo.gl/vYNvU1Vbsnwt5Vui6",
    moreInfo: "https://www.keralatourism.org/destination/muzhapilangad-beach/85/",
    image: cloudImg('Muzhappilangad_Drive-in_Beach.jpg')
  },
  {
    id: "kizhunna",
    title: "KIZHUNNA BEACH",
    description: "Discover a hidden paradise where dramatic rocky formations meet crystal-clear turquoise waters in perfect harmony. Kizhunna Beach represents the untouched beauty of Kerala's coastline, offering visitors an intimate connection with nature's raw splendor.",
    features: [
      { highlight: "Dramatic Landscapes", details: "Marvel at the stunning contrast between ancient black rocks carved by centuries of waves and the pristine golden sand beaches. These natural sculptures create countless photo opportunities and peaceful meditation spots." }
    ],
    location: "https://maps.app.goo.gl/sA2QxWREuquJDxuw9",
    moreInfo: "https://www.keralatourism.org/destination/kizhunna-beach-kannur/322/",
    image: cloudImg('kizhunna_beach.jpg')
  },
  {
    id: "meenkunnu",
    title: "MEENKUNNU BEACH",
    description: "A photographer's dream destination where striking geological contrasts create one of Kerala's most visually stunning coastal landscapes. The dramatic interplay between ancient black rocks and golden sand creates an otherworldly beauty that captivates every visitor.",
    features: [
      { highlight: "Striking Black Rocks", details: "Ancient volcanic rocks, sculpted by millennia of wave action, create dramatic formations that serve as perfect natural viewing platforms and photography backdrops." }
    ],
    location: "https://maps.app.goo.gl/QguY1Sqf32sTidur5",
    moreInfo: "https://www.keralatourism.org/destination/meenkunnu-beach-kannur/411/",
    image: cloudImg('meenkunnu_beach.jpg')
  },
  {
    id: "dharmadam",
    title: "DHARMADAM ISLAND",
    description: "A secluded, uninhabited island just 100 meters off Dharmadam Beach, Dharmadam Island offers a tranquil escape surrounded by rivers on three sides and the Arabian Sea on the fourth.",
    features: [
      { highlight: "River-Sea Confluence", details: "Enjoy breathtaking views of the meeting point of the Anjarakandy and Thalassery rivers with the Arabian Sea as you stroll along the island's periphery." }
    ],
    location: "https://maps.app.goo.gl/nVRsCPNtWTjL1BzY9",
    moreInfo: "https://www.keralatourism.org/destination/dharmadam-island-kannur/89/",
    image: cloudImg('dharmadam_island.jpg')
  },
  {
    id: "baby",
    title: "BABY BEACH",
    description: "Discover this intimate coastal gem tucked between the famous Payyambalam Beach and the historic St. Angelo Fort. Baby Beach offers a more secluded alternative for those seeking peace and tranquility away from larger beach crowds.",
    features: [
      { highlight: "Historic Setting", details: "Located adjacent to the 16th-century St. Angelo Fort, the beach combines natural beauty with historical significance, offering visitors both relaxation and cultural exploration." }
    ],
    location: "https://maps.app.goo.gl/6SepuN5rw7UjpXTv8",
    moreInfo: "https://www.thrillophilia.com/attractions/baby-beach",
    image: cloudImg('baby_beach.jpg')
  },
  {
    id: "thottada",
    title: "THOTTADA BEACH",
    description: "Experience the magical phenomenon where river meets sea at this pristine 800-meter stretch of coastline. Thottada Beach represents unspoiled natural beauty where fresh water mingles with salt water, creating a unique ecosystem and spectacular scenery.",
    features: [
      { highlight: "River-Sea Confluence", details: "Witness the fascinating meeting point where the river's fresh water flows into the Arabian Sea, creating unique patterns, colors, and a diverse aquatic ecosystem." }
    ],
    location: "https://maps.app.goo.gl/PJH15Rx6WBjLrUdH9",
    moreInfo: "https://www.thrillophilia.com/attractions/thottada-beach",
    image: cloudImg('thotada_beach.jpg')
  },
  {
    id: "ettikulam",
    title: "ETTIKULAM BEACH",
    description: "A pristine coastal destination that perfectly balances natural beauty with accessibility, making it one of the most welcoming and photogenic beaches in the Kannur region. This well-maintained paradise offers visitors the perfect combination of convenience and natural splendor.",
    features: [
      { highlight: "Pristine Condition", details: "Meticulously maintained by local communities, the beach showcases how natural beauty and responsible tourism can coexist harmoniously." }
    ],
    location: "https://maps.app.goo.gl/2gvWrsgAQFWHs2CJA",
    moreInfo: "https://www.tripadvisor.ca/Attraction_Review-g777115-d8075092-Reviews-Ettikulam_Beach-Kannur_Kannur_District_Kerala.html",
    image: cloudImg('ettikulam_beach.jpg')
  },
  {
    id: "choottada",
    title: "CHOOTTADA BEACH",
    description: "Experience one of Kerala's last untouched coastal wilderness areas, where pristine nature remains exactly as it has for centuries. This undeveloped paradise offers visitors a rare glimpse into the authentic, unspoiled beauty of the Malabar Coast.",
    features: [
      { highlight: "Ezhimala Hills Backdrop", details: "Enjoy stunning views of the majestic Ezhimala hills rising dramatically behind the beach, creating a spectacular mountain-meets-sea landscape rarely found along India's coast." }
    ],
    location: "https://maps.app.goo.gl/ncNhUT2mLEzhxCkSA",
    moreInfo: "https://www.keralatourism.org/ebooks/expect-the-unexpected/chootad-beach/9",
    image: cloudImg('choottad_beach.jpg')
  }
];
